import CrudActions from "@/store/Crud/classes/CrudActions";
import CrudResetActions from "@/store/Crud/classes/CrudResetActions";
export const crudActions = new CrudActions();
export const crudResetActions = new CrudResetActions();
export function getOne(store, options) {
    return crudActions.getOne(store, options);
}
export function findOne(store, options) {
    return crudActions.findOne(store, options);
}
export async function findAll(store, options) {
    await crudActions.findAll(store, options);
}
export async function filter(store, options) {
    await crudActions.filter(store, options);
}
export async function create(store, options) {
    await crudActions.create(store, options);
}
export async function simplePost(store, options) {
    await crudActions.simplePost(store, options);
}
export async function update(store, options) {
    await crudActions.update(store, options);
}
export async function del(store, options) {
    await crudActions.delete(store, options);
}
export function resetList(store, options) {
    crudResetActions.resetList(store, options);
}
export function resetSave(store, options) {
    crudResetActions.resetSave(store, options);
}
export function dispatchGlobalError(store) {
    store.dispatch("global-message/setMessage", {
        text: "",
        type: "error",
    }, { root: true });
}
